import { ITableHeader } from '@base/@types/components/Layout/TableGrid'
import { IParamsToSend } from '@base/@types/providers/Budget/Report'

export const validateIfShowColumnInTable = (
  headers: ITableHeader[],
  paramsToSend: IParamsToSend
) => {
  let newHeaders: ITableHeader[] = []
  newHeaders = [...headers]

  const headersFormatted: ITableHeader[] = newHeaders.map(item => {
    return (item = {
      group: item.group,
      columns: item.columns.map(column => {
        if (column.id === 'orcamento-empresa') {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.empresa.agrupar
          })
        }
        if (column.id === 'orcamento-loja') {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.loja.agrupar
          })
        }
        if (column.id === 'orcamento-mes') {
          return (column = {
            id: column.id,
            name: column.name,
            show: paramsToSend.mes.agrupar
          })
        }

        return column
      })
    })
  })

  return headersFormatted
}
